import { Button, message, Page, Text, Col } from 'components';
import styled from 'styled-components';
import axios from 'axios';
import React from 'react';

import { Loading } from '@app/react-common';

const AddUsersToTeamsQAPage = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isDone, setIsDone] = React.useState(false);

  const performAction = async (cb: () => Promise<void>) => {
    try {
      setIsDone(false);
      setIsLoading(true);
      await cb();
      setIsDone(true);
    } catch (err) {
      message.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = async () => {
    performAction(async () => {
      await axios.post('/team/qa_page/add_users_to_teams');
    });
  };

  if (isLoading) return <Loading />;

  return (
    <Page type="filled" title="Automatically Add Users to Teams QA Page">
      <Layout>
        <Text>
          This will trigger the same function used during the daily cron to
          automatically add users to teams based on the Team MLS ID in the web
          app.
        </Text>
        <Col span={16}>
          <Button onClick={handleAdd}> Add Users! </Button>
        </Col>

        {isDone && <Text>Done!</Text>}
      </Layout>
    </Page>
  );
};

export default AddUsersToTeamsQAPage;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;
